import { defineComponent as B, computed as w, ref as u, reactive as j, watch as d, onMounted as T, onBeforeUnmount as $, createElementBlock as f, openBlock as v, Fragment as k, createElementVNode as s, normalizeStyle as x, createCommentVNode as q, withModifiers as I, toDisplayString as C, renderList as P, normalizeClass as z } from "vue";
import { EditorClasses as A } from "../styles.js";
const H = { class: "container" }, M = {
  key: 0,
  class: "level-1"
}, N = ["id"], D = ["href", "onClick"], R = /* @__PURE__ */ B({
  __name: "TableOfContents",
  props: {
    headings: {},
    pageTitle: {}
  },
  setup(O) {
    const g = O, m = w(
      () => Object.values(g.headings || {}).filter((e) => e.level === 1 || e.level === 2 || e.level === 3).map((e) => e.slug)
    ), r = u(""), a = u(""), o = j({}), i = w(
      () => Object.values(o).sort((e, t) => e.order - t.order)
    ), p = u([]), h = u(0);
    function _() {
      Object.keys(o).forEach((e) => {
        m.value.includes(e) || delete o[e];
      }), m.value.forEach((e, t) => {
        var l;
        o[e] = {
          id: e,
          inView: ((l = o[e]) == null ? void 0 : l.inView) ?? !1,
          order: t
        };
      });
    }
    d(m, () => _(), { immediate: !0, deep: !0 });
    const E = (e) => {
      e.forEach((t) => {
        if (o[t.target.id] && (o[t.target.id].inView = t.isIntersecting), a.value = t.target.id, !t.isIntersecting && t.target.getBoundingClientRect().top >= window.innerHeight * 0.2 && Object.values(o).every((c) => !c.inView)) {
          const c = i.value.findIndex(
            (S) => S.id === t.target.id
          );
          c >= 1 && (a.value = i.value[c - 1].id);
        }
      });
    };
    d(
      [a, i],
      () => {
        const e = i.value.find((t) => t.inView);
        if (e) {
          r.value = e.id;
          return;
        }
        if (a.value) {
          r.value = a.value;
          return;
        }
      },
      { immediate: !0, deep: !0 }
    );
    let n;
    function y() {
      n && n.disconnect(), document.querySelectorAll(
        '[data-scalar-type="heading"][data-level="1"], [data-scalar-type="heading"][data-level="2"], [data-scalar-type="heading"][data-level="3"]'
      ).forEach((t) => n == null ? void 0 : n.observe(t));
    }
    T(() => {
      n = new IntersectionObserver(E, {
        // threshold: 1,
        // rootMargin: '-20%',
      }), y();
    }), $(() => n == null ? void 0 : n.disconnect()), d(
      () => Object.keys(g.headings || {}),
      () => {
        p.value = [], y();
      }
    );
    function b(e) {
      r.value = e.parent || e.slug, window.location.replace(`#${e.slug}`);
      const t = document.getElementById(e.slug);
      t == null || t.scrollIntoView();
    }
    function V() {
      const e = document.querySelector(`.${A.PageTitle} h1`);
      e == null || e.scrollIntoView();
    }
    return d(r, () => {
      const e = p.value.find(
        (t) => {
          var l;
          return ((l = t.querySelector(".anchor")) == null ? void 0 : l.getAttribute("href")) === `#${r.value}`;
        }
      );
      e && (h.value = e.offsetTop);
    }), (e, t) => (v(), f(k, null, [
      t[0] || (t[0] = s("h4", null, "On This Page", -1)),
      s("div", H, [
        s("div", {
          class: "outline-marker",
          style: x({
            transform: `translateY(${h.value}px)`
          })
        }, null, 4),
        s("ul", null, [
          Object.keys(e.headings || {}).length === 0 ? (v(), f("li", M, [
            s("a", {
              class: "anchor",
              href: "#",
              onClick: I(V, ["prevent"])
            }, C(e.pageTitle), 1)
          ])) : q("", !0),
          (v(!0), f(k, null, P(e.headings, (l) => (v(), f("li", {
            id: l.uid,
            key: l.uid,
            ref_for: !0,
            ref_key: "tocItems",
            ref: p,
            class: z([
              `level-${l == null ? void 0 : l.level}`,
              { active: r.value === l.slug }
            ])
          }, [
            s("a", {
              class: "anchor",
              href: `#${l.slug}`,
              onClick: I(() => b(l), ["prevent"])
            }, C(l.name), 9, D)
          ], 10, N))), 128))
        ])
      ])
    ], 64));
  }
});
export {
  R as default
};
